var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplashModeration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 678 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 241,
    y: 112,
    width: 32.83,
    height: 47.25,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 126,
    r: 14,
    style: {
      fill: "#fff"
    }
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 245.18,
    y1: 313.4,
    x2: 249.77,
    y2: 315.14,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54b9c7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 238.2,
    y: 59.9,
    width: 31.03,
    height: 51.56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 90,
    r: 14,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 240.17,
    y: 238.7,
    width: 30,
    height: 36.74,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 253,
    r: 14,
    style: {
      fill: "#fff"
    }
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 251,
    y1: 200.21,
    x2: 252.24,
    y2: 185.69,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db8d6b"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 238.8,
    y1: 185.34,
    x2: 264.98,
    y2: 198.17,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d67569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e39e7f"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 237.57,
    y: 203,
    width: 31.43,
    height: 35.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 217,
    r: 14,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 438.75,
    y: 139,
    width: 121.25,
    height: 138.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 193,
    r: 54,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 237.57,
    y: 332,
    width: 31.43,
    height: 35.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 346,
    r: 14,
    style: {
      fill: "#fff"
    }
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Updated-Image-Charlie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 18,
    width: 270,
    height: 369,
    rx: 8,
    style: {
      fill: "#292841"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 198,
    width: 226,
    height: 38,
    rx: 4,
    style: {
      fill: "#807cef",
      fillOpacity: 0.09000000357627869
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 126,
    r: 14,
    style: {
      fill: "#cfdeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.6,144.8a4.1,4.1,0,0,0-1.2-1.7,3.7,3.7,0,0,0-2-.7l-1.4-.2c-2.1-7.6-1.1-9.3-7.3-11l-5-.2s-5.2.1-7.1,2.6l2.7,8.7s-1.1,5.7-.6,8.6l6.6-.9,2.8,9.3c10.7-1.6,15.7-6.6,15.7-6.6Z",
    style: {
      fill: "#cfdeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,131.7c7.2,6.7,13.7,11.3,12.6.7Z",
    style: {
      fill: "#b8c5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4,132.5c6.2,2.9,7.8,4,7.4.5Z",
    style: {
      fill: "#5697b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,137.4c-.8-3.2-1.3-4.6-4.5-5.7a30.3,30.3,0,0,1,1.2,6.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,122l-.3-1.8a2.1,2.1,0,0,0-.7-1.5,2.2,2.2,0,0,0-1.5-.8,2.8,2.8,0,0,0-1.8.3,2.4,2.4,0,0,0-1.2,1.4c-.8,2.2-2.1,5.7-2.9,8.6-1.4,4.7,4.8,5.8,10.9,5.3s6.7-3.1,5.9-7c-.6-2.4-1.3-4.9-1.7-6.4a2.6,2.6,0,0,0-.7-1.1,2.4,2.4,0,0,0-2.7-.2,3.1,3.1,0,0,0-.9,1.1l-.7,1.8Z",
    style: {
      fill: "#7ce4cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,128.4l-.4-.2-2.2.8-2.3.3-3.9-.8s-2.2-3.3-2,.4a6.9,6.9,0,0,0,1.9,4.7h3.9a9.3,9.3,0,0,0,2.9-.5A10.4,10.4,0,0,0,261.7,128.4Z",
    style: {
      fill: "#aafae7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,128.6c-.5-1.4-1.4-4.4-1-6.6s.9-4.1,1.9-4.1a2.8,2.8,0,0,0-1.8.3,2.4,2.4,0,0,0-1.2,1.4c-.8,2.2-2.1,5.7-2.9,8.6s3.6,5.5,9,5.4C253.6,133.4,252.1,132.2,250.8,128.6Z",
    style: {
      opacity: 0.7400000095367432,
      isolation: "isolate",
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,133.6h-2a6.5,6.5,0,0,1-1.9-4.7h0C252.2,132.2,253.6,133.4,254.8,133.6Z",
    style: {
      fill: "#aafae7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2,128v.5c-2.4,1.6-2.8,2-8.9.1v-.5h.3C257.7,129.5,258.7,129.6,261.2,128Z",
    style: {
      fill: "#2c4661"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.8,130a1.5,1.5,0,0,0,1-2,1.6,1.6,0,0,0-1.9-1.3,1.8,1.8,0,0,0-1,2.1A1.6,1.6,0,0,0,251.8,130Z",
    style: {
      fill: "#738eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,128.1c.2-.7,0-1.5-.5-1.5s-.9.4-1.1,1.2.1,1.5.5,1.6S262.2,128.9,262.3,128.1Z",
    style: {
      fill: "#738eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,126.6c-.2-.1,0-.2.2-.3h.4l.5.7c.2.3-.1.3-.3.1S256.4,126.9,256.3,126.6Z",
    style: {
      fill: "#284e7a",
      opacity: 0.4099999964237213,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,127v-.6a.3.3,0,0,0-.1-.2h-.2l-.3.9C258.5,127.3,258.7,127.3,258.9,127Z",
    style: {
      fill: "#284e7a",
      opacity: 0.4099999964237213,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,122.1h-2.1l1.7-.3.7-1.8a3.1,3.1,0,0,1,.9-1.1,2.1,2.1,0,0,1,1.5-.3h.4c-1-.2-1.4,1-1.6,2.4S257.7,122.2,256.3,122.1Z",
    style: {
      fill: "#61c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,121.8c0-.6-.3-1-.8-1a1,1,0,0,0,0,2A1,1,0,0,0,260.4,121.8Z",
    style: {
      fill: "#21354a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,121.5c.1-.6-.2-1.1-.7-1.1s-.8.3-.9.9a1,1,0,0,0,.7,1.1A.9.9,0,0,0,252.7,121.5Z",
    style: {
      fill: "#21354a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,142.3l3.2-.2a6.2,6.2,0,0,1,.1-1.3,7,7,0,0,1,.8-2l-2.8-.2c-.2-4.2-2.4-6.5-3.6-5.3a2.8,2.8,0,0,0-1,2.1,11.8,11.8,0,0,0,0,1.9c-.1.8-.7,1,0,2.5S245.7,142.2,249.3,142.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.2,118a3.7,3.7,0,0,1,1.2,2.5,14.9,14.9,0,0,1,.2,1.7c.1.3.1.4,1,.7s.5.1.1-.4l-.5-.5-.3-1.8a2.1,2.1,0,0,0-.5-1.3A2.7,2.7,0,0,0,252.2,118Z",
    style: {
      fill: "#d4ffdc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9,121.1c.4.1.4.9.1.6S259.5,121,259.9,121.1Z",
    style: {
      fill: "#335a70"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3,120.7c.3.1.4.9.1.6S251.9,120.6,252.3,120.7Z",
    style: {
      fill: "#335a70"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3,129c.3-.1.3-.7,0-1.2s-.7-.8-1-.6-.3.7-.1,1.2S252,129.2,252.3,129Z",
    style: {
      fill: "#b2a6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,127.5c0-.4-.1-.7-.3-.7s-.3.3-.3.7.1.7.3.7S262.3,127.9,262.3,127.5Z",
    style: {
      fill: "#b2a6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,119.2c.5.4.7,1.1.1.6S259.4,118.8,260,119.2Z",
    style: {
      fill: "#d4ffdc"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M464,51.1h-7.1V44h-1.8v7.1H448v1.8h7.1V60h1.8V52.9H464Z",
    style: {
      fill: "#8684bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-2)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 90,
    r: 14,
    style: {
      fill: "#628bf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.9,66.1l10.4,19.5a3.2,3.2,0,0,1,.3,1.4,2.1,2.1,0,0,1-.7,1.3v.2a14.8,14.8,0,0,1-13.6,4.1,1.8,1.8,0,0,1-.9-.6,1.5,1.5,0,0,1-.3-1l-.5-23.5C246.4,58.7,246.9,56.7,251.9,66.1Z",
    style: {
      fill: "#33beb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,88.5a3.5,3.5,0,0,0,.7-1.5,3,3,0,0,0-.3-1.6L251.9,66.1c-2.4-4.6-3.8-6.5-4.5-6.1,1.9,13.6,6,31.4,6,31.4l2.7.7A15.4,15.4,0,0,0,261.8,88.5Z",
    style: {
      fill: "#33a2be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,79.9c-.7-1.2-.9-1.5-1.2-1-4.3-6.8-6.4-5.4-6.4,1.2,0,0-3-1.6-2.6,4.3a2.9,2.9,0,0,0-1.3,0,2.2,2.2,0,0,0-1,.9L247,91a2,2,0,0,0,.2.9,1.3,1.3,0,0,0,.7.6,16.2,16.2,0,0,0,7.6-.6,16.8,16.8,0,0,0,6.6-3.8,2.9,2.9,0,0,0,.5-1.3,2.7,2.7,0,0,0-.3-1.2Z",
    style: {
      fill: "#f7e5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,85.6l-3-5.7c-.7-1.2-.9-1.5-1.2-1-4.3-6.8-6.4-5.4-6.4,1.2l-.8-.2c.8.2.9,1,1.4,2.8s.8,3.4.8,3.4l7.6,3.2,1.4-1.2a2.9,2.9,0,0,0,.5-1.3A2.7,2.7,0,0,0,262.3,85.6Z",
    style: {
      fill: "#f7d197"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,85.8c-3.7-3.9-7-5.3-14.4,5.5,0,.1-.1.2-.1.4a.8.8,0,0,0,.1.4c0,.1.1.2.2.3l.4.2a15.1,15.1,0,0,0,7.3-.3,15.7,15.7,0,0,0,6.3-3.8v-.2l.3-.4a2.3,2.3,0,0,0,.3-1.1A3.1,3.1,0,0,0,262,85.8Z",
    style: {
      fill: "#242236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3,89.2l-.9-4.9c-2.7-2.2-5.6-2.3-10.3,3.7l2,4.6A19.1,19.1,0,0,0,261.3,89.2Z",
    style: {
      fill: "#9e4b34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,89l-3.5-.3-.5,1.3-.9-1.8c-.8-2-.8-1.9-1.6-.3s-3.9,1.1-3.9,1.1l-.7-1.5c4.2-5.1,6.8-5.3,9.3-3.7Z",
    style: {
      fill: "#7a2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.7,95.7l.6-1.7a1.6,1.6,0,0,1,.6-.8l.9-.5,2.5-.4,9.7-.2,5.3,2.6.5.5a.9.9,0,0,1,.3.7l.2,1.2,2.5,1.7a.8.8,0,0,1,.4.4v.5c-.7,5.8-6.7,14.8-15,10.8a77.4,77.4,0,0,1-14.8-9.6l-1.1,1.5a2.3,2.3,0,0,1,.9-2.7l.8-.6a2,2,0,0,0,.1-.7c.3-1.2,0-1.4,1.3-1.7Z",
    style: {
      fill: "#33beb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,92.8c-2.2.4-3.5.4,0,2.4S250.3,92.8,250.3,92.8Z",
    style: {
      fill: "#1e6470"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5,85.9l.4,1.7h.9l-.6-1.4h0v-1l-.6.4Z",
    style: {
      fill: "#66251f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,87.6l1.3.2C253.9,88.5,253.3,88.4,253.1,87.6Z",
    style: {
      fill: "#5e221d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,87.1l1.3-.4C259,87.6,258.4,87.7,257.8,87.1Z",
    style: {
      fill: "#5e221d"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.9,87.8c.2,0,.4-.3.4-.6s-.2-.7-.4-.7-.4.3-.4.7S253.7,87.8,253.9,87.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5,87c.3,0,.4-.3.4-.7s-.1-.7-.4-.7-.3.3-.3.7S258.3,87,258.5,87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.8,83.8l1.1.9c.3,1,.5,2.5.9,3.8s.9,3.1.6,4.1,0,1.2.7,2.5,1.9,2.8,1.5,4.5.4,1.7.2,2.7-1,3.7-2.8,3.7a5.3,5.3,0,0,1-2.5,1.9,5.4,5.4,0,0,1-3.1.1c-2.9-.7-5.8-2.7-5.5-5.4-1-.7-.8-2.8-.6-3.9a5.6,5.6,0,0,0-.5-2.8,8.7,8.7,0,0,1,0-4,11.1,11.1,0,0,1-.7-2.6l1.4-1.9.7,1.6.9,2a1,1,0,0,1,.7-.2,2.4,2.4,0,0,1,.8-.9,1.7,1.7,0,0,1,1.2-.4l2.8.5.5-1.3a3.8,3.8,0,0,1,2.5.1,4.4,4.4,0,0,0,.1-2.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,91.1l-1.1-.2c-.5-.1-.5-.2-1.9-1.4l2.8.5.5-1.3a3.8,3.8,0,0,1,2.5.1,4.4,4.4,0,0,0,.1-2.3l-.9-2.7,1,.9c.4,1,.6,2.5,1,3.8s.9,3.1.6,4.1,0,1.2.7,2.5,1.9,2.8,1.5,4.5.4,1.7.2,2.7-1,3.7-2.8,3.7a5.3,5.3,0,0,1-2.5,1.9,5.4,5.4,0,0,1-3.1.1c-2.9-.7-5.8-2.7-5.5-5.4.9,2.5,2.8,2.1,2.8,2.1a14.7,14.7,0,0,1,3.6-.4,9.7,9.7,0,0,1,2.2-2.8c1.4-2.8.3-5.7-.4-7.3Z",
    style: {
      fill: "#d6dfff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,91.1c.7.2.7-.4.7-1.1a6.5,6.5,0,0,0-.4-1.3l-.5,1.3-2.8-.5c1.4,1.2,1.4,1.3,1.9,1.4Z",
    style: {
      fill: "#cad5fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4,86.8,255,86l-.7-.2h-.7l-.7.4A1,1,0,0,0,252.4,86.8Z",
    style: {
      fill: "#cfdeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,85.7l2.7-.5a1.9,1.9,0,0,0-2.7.5Z",
    style: {
      fill: "#cfdeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,92.2l-.2.4a.5.5,0,0,1-.5.3c-2.9.4-4.1-.3-4.6-.7V92c-.1-.1-.1-.2,0-.2h0a10.9,10.9,0,0,0,4.3.2c.6-.1.4-.3.3-.5h.3l.3.2c0,.1.1.2.1.3A.4.4,0,0,1,259,92.2Z",
    style: {
      fill: "#de5d70"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,79.5c.5-.2.6-1.1.2-2s-1.2-1.3-1.6-1.1-.6,1.1-.2,2S255,79.7,255.4,79.5Z",
    style: {
      fill: "#ff9ccd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6,77.5c-.4-.9-1.2-1.4-1.7-1.2s-.1.1-.1.2h-.1C254.5,76.6,254.1,77.5,255.6,77.5Z",
    style: {
      fill: "#ffebf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,77.2a5.3,5.3,0,0,0,.3,1.2l.2.2c.1,0,.5-.1.6.1s.3.7.9.8l.3-.4a4.3,4.3,0,0,0,.1-.5h-.2C254.7,78.6,254.1,77.6,253.5,77.2Z",
    style: {
      fill: "#ff70b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,82.6c.3,0,.5-.2.5-.6a.6.6,0,0,0-.5-.6.6.6,0,0,0-.5.6A.6.6,0,0,0,250.5,82.6Z",
    style: {
      fill: "#f7d197"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,86.8a.7.7,0,0,0,.5-.7.6.6,0,0,0-.5-.6.6.6,0,0,0-.5.6C247.5,86.5,247.7,86.8,248,86.8Z",
    style: {
      fill: "#f7d197"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,89.3a7.9,7.9,0,0,0,.6,2.2,1.7,1.7,0,0,1,.6-1.4c.4-.1.4-1.1.9-1.1l-.7-1.6Z",
    style: {
      fill: "#a8c3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,94.7c1.2,1.2,1.7,2,1.7,2.7a4.6,4.6,0,0,1-1.3-.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,85.1l3.2-.7C256.2,84.2,255.2,84.5,254.7,85.1Z",
    style: {
      fill: "#66251f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,87.2a1.4,1.4,0,0,0,.2.6,2.1,2.1,0,0,0,.4.6c.2.1,0-.2-.3-.8S255.7,86.8,255.8,87.2Z",
    style: {
      fill: "#c27059"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.3,96l-.3-1.9h-3.7V85h-2.1V96Zm8-3.9a3.7,3.7,0,0,0-3.7-4c-2.1,0-3.6,1.5-3.6,4s1.5,4.1,3.6,4.1S292.3,94.6,292.3,92.1Zm-1.9,0c0,1.5-.6,2.5-1.8,2.5s-1.7-1-1.7-2.5.6-2.4,1.7-2.4S290.4,90.7,290.4,92.1Zm9.2,3.3-.2-1.6a3.5,3.5,0,0,1-2,.7c-1.2,0-2-.8-2-2.4s.8-2.3,1.9-2.3a2.9,2.9,0,0,1,2,.7l.3-1.7a4.3,4.3,0,0,0-2.4-.7c-2.1,0-3.8,1.4-3.8,4.1s1.5,3.9,3.7,3.9A4.1,4.1,0,0,0,299.6,95.4Zm6.3.7,2.1-.3-3.1-4,2.9-3.5h-2.2l-2.5,3.2V84.4l-1.9.4V96h1.9V92.2Zm6.1-6.7c.9,0,1.4.7,1.5,1.9h-3.1C310.5,90.1,311.2,89.4,312,89.4Zm3.3,5.8-.2-1.5a4.2,4.2,0,0,1-2.6,1c-1.2,0-2-.7-2.1-2.2h4.9a4.3,4.3,0,0,0,.1-.5c0-2.1-1.1-3.9-3.4-3.9s-3.5,1.5-3.5,4,1.6,4.1,3.8,4.1A4.9,4.9,0,0,0,315.3,95.2Z",
    style: {
      fill: "#dcddde"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-3)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 253,
    r: 14,
    style: {
      fill: "#ff82a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,242.3h0l-.2.3h0v.2c-2.1,4.9-6.1,8.5-8.7,11a39.5,39.5,0,0,1-9.3,6.4c-3.3,1.6-4.7.2-4.4-2.5l.4-1.4,1.6-6.8v-.3c1.2-4.5,2.9-7,8.4-8.4l8.4-2.1h0C261.9,238.2,264,239.2,262.9,242.3Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,239c-2.6.4-7.6,3.6-12.6,8.3s-8.7,9.9-9,12.5,1.9,1.8,4.2.6a39.5,39.5,0,0,0,9.3-6.4c2.6-2.5,6.6-6.1,8.7-11v-.2h0l.2-.3h0C263.5,240.5,263.1,239.4,262,239Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1,252.2c4.8-4.5,8-9,7.2-9.9s-5.5,2-10.3,6.6-8,9-7.2,9.9S249.3,256.8,254.1,252.2Z",
    style: {
      fill: "#6b3143"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,260.1l-1.3,1a1.9,1.9,0,0,0-.7.8,1.7,1.7,0,0,0-.3,1l-.3,1.7-2.2,2a3,3,0,0,0-.8,1.8v1.5s12.3,6.6,18.9,5.4,2.6-12.5,2.6-12.5l-.3-.2h-.3l-2-.2-.8-2a1,1,0,0,0-.4-.5l-.5-.3-5.8-1.2Z",
    style: {
      fill: "#ef6270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4,263.6c-1.8-.4-1.6-.3-1.1-1.1a2.8,2.8,0,0,1,1.2-1.2Z",
    style: {
      fill: "#bd3c53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.1,247.3c-.2-.2-2,1.1-3.9,2.9s-3.4,3.4-3.2,3.7a29.7,29.7,0,0,1,4.4,9.7l9.6,1.8C262.5,256.9,258.5,251.1,256.1,247.3Z",
    style: {
      fill: "#ffb685"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,254.9a.5.5,0,0,0-.5-.5.6.6,0,0,0-.2.7c.1.3.3.5.5.4S259.8,255.2,259.7,254.9Z",
    style: {
      fill: "#543247"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,256.7a.7.7,0,0,0-.3-.8c-.2-.2-.6-.2-.7,0a.5.5,0,0,0,.2.8A.6.6,0,0,0,256.6,256.7Z",
    style: {
      fill: "#543247"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6,259.6c.8-.4,1.5-.8,1.8-.7s.2.7-.1,1.5-.3.4-1.2.1S257.9,259.9,258.6,259.6Z",
    style: {
      fill: "#c74153"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,259.5l-.6.4c0,.3.4.5.8.6s1,.2,1.2-.1V260A1.9,1.9,0,0,0,258.9,259.5Z",
    style: {
      fill: "#a82c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1,258.9l-1.5.7c-.4.2-.4.4-.2.5l1.8-.8C260.3,259.3,260.2,259.1,260.1,258.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4,256.4h0a1.3,1.3,0,0,0-.3-.8l-.7-.4.2.3v.2a.4.4,0,0,1-.1.3h-.1a1.6,1.6,0,0,1-.9.3,2.5,2.5,0,0,0-1.1.4,2,2,0,0,0-.8.8c-1.4-.1-1.8.8-2.8,1.2a1.1,1.1,0,0,1-.8.3c-1,.2-1.1-.2-1.1-.7a1.3,1.3,0,0,0,.4,2.3,1.9,1.9,0,0,0,1.8-.4c1.6.4,2.2.2,3.2-1.4,1.6.4,2.6-.2,2.6-1.7l.4-.3C262.4,256.7,262.4,256.6,262.4,256.4Z",
    style: {
      fill: "#6b3143"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,258.8c1.6.4,2.6-.2,2.7-1.7l.3-.3c.1-.1.1-.2.1-.4h0c0-.2,0-.3-.1-.4a.7.7,0,0,1-.2.6.5.5,0,0,1-.5.3,2.1,2.1,0,0,1-2.6,1.1s-1.2,1.7-2.9,1.3-2.5.9-2.8-.1a2.4,2.4,0,0,0,.2.9,1.6,1.6,0,0,0,.8.6,1.9,1.9,0,0,0,1.8-.4C257.7,260.6,258.3,260.4,259.3,258.8Z",
    style: {
      fill: "#5e2737"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,258.2l-.3-1.8a4.5,4.5,0,0,1-2.8,1c-2,0-3.2-1.5-3.2-3.9s1.2-3.9,3.2-3.9a3.8,3.8,0,0,1,2.6,1l.3-2a5.3,5.3,0,0,0-3-.8c-3.2,0-5.3,2.3-5.3,5.7s2.1,5.7,5.3,5.7A5.5,5.5,0,0,0,286.2,258.2Zm5.9-1.3a2.9,2.9,0,0,1-1.8.8c-.6,0-1-.3-1-.9s.5-1.4,2.8-1.7ZM294,259v-5.3c0-1.9-1-2.6-3-2.6a9.5,9.5,0,0,0-3.1.6l.3,1.6a5.5,5.5,0,0,1,2.5-.7c.9,0,1.4.4,1.4,1.2v.2c-3.2.3-4.7,1.1-4.7,3a2,2,0,0,0,2.2,2.2,4,4,0,0,0,2.6-1.2v1Zm7-4c0,1.7-.7,2.5-1.7,2.5a3.3,3.3,0,0,1-1.5-.3v-3.3a2.2,2.2,0,0,1,1.7-1.1C300.4,252.8,301,253.5,301,255Zm2-.1c0-2.6-1.3-3.8-2.9-3.8a3.1,3.1,0,0,0-2.4,1.2l-.2-1h-1.6V262l1.9-.3v-2.9a4.8,4.8,0,0,0,1.8.3C301.4,259.1,303,257.8,303,254.9Z",
    style: {
      fill: "#dcddde"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-4)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 217,
    r: 14,
    style: {
      fill: "#ffb869"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,221.6c1.6,5.7,8.2,9.6,13.5,5.9s0-11.4,0-11.4,2.9-7.2-4.3-8.9S248.1,208.6,247.8,221.6Z",
    style: {
      fill: "#4d7ae8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4,217.4c-.8,0-1.4-.9-1.4-1.9s.6-1.9,1.4-1.9a1.7,1.7,0,0,1,1.5,1.9A1.8,1.8,0,0,1,258.4,217.4Z",
    style: {
      fill: "#dbe7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,216.9c-.2,0-.4-.3-.4-.7s.2-.7.5-.7.3.4.3.8S259.3,217,259.1,216.9Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1,211.9a1.3,1.3,0,0,0-.5-.7l-.9-.3a1.1,1.1,0,0,0-.8.3c-.3.1-.4.4-.5.7Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,220.1a4.1,4.1,0,0,1-4.2-1.3,1,1,0,0,0-.7-.4l-.7.2a1.6,1.6,0,0,0-.4.7,1,1,0,0,0,.2.7c1.9,3.1,4.9,3.6,6.8,1.8a.5.5,0,0,0,.2-.4.9.9,0,0,0,.1-.5c-.1-.1-.1-.3-.2-.4l-.3-.3H260Z",
    style: {
      fill: "#590942"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,220.2h1.4v.9s-.6.4-2.6.2v-.5l-3.7-1.2c0-.2.1-.3.1-.5l.3-.3h1.4a2.3,2.3,0,0,0,.7.7l.5.3.8.4Z",
    style: {
      fill: "#dbe7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,218.6h.1a.4.4,0,0,1,.5-.1h.8c.1.1.2.3.4.4l-1.1.6-1.1-.4c0-.1.1-.2.1-.4Z",
    style: {
      fill: "#b5cdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,209.8c1.4-2.9,3.7-3.5,7.7-2.6a9.2,9.2,0,0,1,2.3.9c.2,1.2-1.6,1.6-4.9.5C255.5,210.6,253.2,214.2,249.3,209.8Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,207.1l.2-2.4a1.7,1.7,0,0,0-.1-.7l-.3-.5-.6-.4h-.7l-.7.2-.5.5a2.4,2.4,0,0,0-.2.8.9.9,0,0,0,.1.7l1.1,2.5Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,220.2l1.1.4,2.3-1.5V221l1.9,1.5a3.5,3.5,0,0,1,1,1.2,4.4,4.4,0,0,1,.5,1.5v1.6c2.9,2.3,6.7,3.1,10.1.7a6.2,6.2,0,0,0,1.4-1.4l1.2.4s-2.3,9.9-6.2,11.7a7.2,7.2,0,0,1-6.7,0c-4-13.9-2.9-16.5-13-12.5l-.4-2.8Z",
    style: {
      fill: "#ef6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,215.8l-7.4-6.9-.7.9,5.7,10.6Z",
    style: {
      fill: "#4d7ae8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,214.3l-2.9-2.1,2.2,4-.4-1.5Z",
    style: {
      fill: "#3366e0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M287,222.1v-5.3h-4.4l.3,1.7h2.2V221a3.6,3.6,0,0,1-1.9.4c-2.2,0-3.3-1.6-3.3-3.9s1.1-3.9,3.2-3.9a5,5,0,0,1,3.1,1l.3-2a6.8,6.8,0,0,0-3.4-.8c-3.3,0-5.4,2.3-5.4,5.7s2,5.7,5.5,5.7A6.8,6.8,0,0,0,287,222.1Zm6.7-5.1-.3-1.9a3.1,3.1,0,0,0-2.5,1.7l-.3-1.5H289V223h1.9v-4.4A3.7,3.7,0,0,1,293.7,217Zm5.1,3.9a2.5,2.5,0,0,1-1.8.8.8.8,0,0,1-.9-.9c0-.7.5-1.4,2.7-1.7Zm1.9,2.1v-5.3c0-1.9-.9-2.6-2.9-2.6a9,9,0,0,0-3.1.6l.2,1.6a6.3,6.3,0,0,1,2.6-.7c.8,0,1.3.4,1.3,1.2v.2c-3.1.3-4.6,1.1-4.6,3a2,2,0,0,0,2.2,2.2,3.5,3.5,0,0,0,2.5-1.2l.2,1Zm6.1-5.2a1.4,1.4,0,0,1-1.3,1.5,1.5,1.5,0,0,1,0-3A1.4,1.4,0,0,1,306.8,217.8Zm2.8,5.5c0-1.2-1-1.7-2.6-1.9h-1c-1.2-.2-1.4-.2-1.4-.5s.1-.2.3-.4h.6c1.7,0,3.1-1,3.1-2.7a3,3,0,0,0-.2-1h1.4l-.3-1.5-1.8.6a3.8,3.8,0,0,0-2.2-.7,2.8,2.8,0,0,0-3.1,2.7,2.3,2.3,0,0,0,1.4,2.3c-.6.4-1,.8-1,1.2a1.4,1.4,0,0,0,.5.9q-1.5.8-1.5,1.8c0,1.3,1.6,1.9,3.7,1.9S309.6,225,309.6,223.3Zm-4,1.5c-1.4,0-2.1-.4-2.1-1a1.7,1.7,0,0,1,.8-1.2l1.2.2h1c1,.2,1.3.4,1.3.8S307,224.8,305.6,224.8Zm9.5-7a1.4,1.4,0,0,1-1.3,1.5,1.5,1.5,0,0,1,0-3A1.4,1.4,0,0,1,315.1,217.8Zm2.8,5.5c0-1.2-1-1.7-2.6-1.9h-1c-1.2-.2-1.4-.2-1.4-.5s.1-.2.3-.4h.6c1.7,0,3.1-1,3.1-2.7a3,3,0,0,0-.2-1h1.4l-.3-1.5-1.8.6a3.8,3.8,0,0,0-2.2-.7,2.8,2.8,0,0,0-3.1,2.7,2.3,2.3,0,0,0,1.4,2.3c-.6.4-1,.8-1,1.2a1.4,1.4,0,0,0,.5.9q-1.5.8-1.5,1.8c0,1.3,1.6,1.9,3.7,1.9S317.9,225,317.9,223.3Zm-4,1.5c-1.4,0-2.1-.4-2.1-1a1.4,1.4,0,0,1,.8-1.2l1.2.2h1c1,.2,1.3.4,1.3.8S315.3,224.8,313.9,224.8Zm7.3-1.8V211.4l-1.9.4V223Zm5.1-6.6c1,0,1.5.7,1.6,1.9h-3.1C324.9,217.1,325.6,216.4,326.3,216.4Zm3.4,5.8-.2-1.5a4.4,4.4,0,0,1-2.6,1c-1.2,0-2-.7-2.1-2.2h4.9a4.3,4.3,0,0,0,.1-.5c0-2.1-1.1-3.9-3.4-3.9s-3.5,1.5-3.5,4,1.6,4.1,3.7,4.1A5,5,0,0,0,329.7,222.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,349.1v-5.3h-4.4l.3,1.7h2.2V348a3.6,3.6,0,0,1-1.9.4c-2.2,0-3.3-1.6-3.3-3.9s1.1-3.9,3.2-3.9a5,5,0,0,1,3.1,1l.3-2a6.8,6.8,0,0,0-3.4-.8c-3.3,0-5.4,2.3-5.4,5.7s2,5.7,5.5,5.7A6.8,6.8,0,0,0,287,349.1Zm6.7-5.1-.3-1.9a3.1,3.1,0,0,0-2.5,1.7l-.3-1.5H289V350h1.9v-4.4A3.7,3.7,0,0,1,293.7,344Zm5.1,3.9a2.5,2.5,0,0,1-1.8.8.8.8,0,0,1-.9-.9c0-.7.5-1.4,2.7-1.7Zm1.9,2.1v-5.3c0-1.9-.9-2.6-2.9-2.6a9,9,0,0,0-3.1.6l.2,1.6a6.3,6.3,0,0,1,2.6-.7c.8,0,1.3.4,1.3,1.2v.2c-3.1.3-4.6,1.1-4.6,3a2,2,0,0,0,2.2,2.2,3.5,3.5,0,0,0,2.5-1.2l.2,1Zm6.1-5.2a1.4,1.4,0,0,1-1.3,1.5,1.5,1.5,0,0,1,0-3A1.4,1.4,0,0,1,306.8,344.8Zm2.8,5.5c0-1.2-1-1.7-2.6-1.9h-1c-1.2-.2-1.4-.2-1.4-.5s.1-.2.3-.4h.6c1.7,0,3.1-1,3.1-2.7a3,3,0,0,0-.2-1h1.4l-.3-1.5-1.8.6a3.8,3.8,0,0,0-2.2-.7,2.8,2.8,0,0,0-3.1,2.7,2.3,2.3,0,0,0,1.4,2.3c-.6.4-1,.8-1,1.2a1.4,1.4,0,0,0,.5.9q-1.5.8-1.5,1.8c0,1.3,1.6,1.9,3.7,1.9S309.6,352,309.6,350.3Zm-4,1.5c-1.4,0-2.1-.4-2.1-1a1.7,1.7,0,0,1,.8-1.2l1.2.2h1c1,.2,1.3.4,1.3.8S307,351.8,305.6,351.8Zm9.5-7a1.4,1.4,0,0,1-1.3,1.5,1.5,1.5,0,0,1,0-3A1.4,1.4,0,0,1,315.1,344.8Zm2.8,5.5c0-1.2-1-1.7-2.6-1.9h-1c-1.2-.2-1.4-.2-1.4-.5s.1-.2.3-.4h.6c1.7,0,3.1-1,3.1-2.7a3,3,0,0,0-.2-1h1.4l-.3-1.5-1.8.6a3.8,3.8,0,0,0-2.2-.7,2.8,2.8,0,0,0-3.1,2.7,2.3,2.3,0,0,0,1.4,2.3c-.6.4-1,.8-1,1.2a1.4,1.4,0,0,0,.5.9q-1.5.8-1.5,1.8c0,1.3,1.6,1.9,3.7,1.9S317.9,352,317.9,350.3Zm-4,1.5c-1.4,0-2.1-.4-2.1-1a1.4,1.4,0,0,1,.8-1.2l1.2.2h1c1,.2,1.3.4,1.3.8S315.3,351.8,313.9,351.8Zm7.3-1.8V338.4l-1.9.4V350Zm5.1-6.6c1,0,1.5.7,1.6,1.9h-3.1C324.9,344.1,325.6,343.4,326.3,343.4Zm3.4,5.8-.2-1.5a4.4,4.4,0,0,1-2.6,1c-1.2,0-2-.7-2.1-2.2h4.9a4.3,4.3,0,0,0,.1-.5c0-2.1-1.1-3.9-3.4-3.9s-3.5,1.5-3.5,4,1.6,4.1,3.7,4.1A5,5,0,0,0,329.7,349.2Z",
    style: {
      fill: "#dcddde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5,128.8a2.6,2.6,0,0,0-2.1-2.7,2.3,2.3,0,0,0,1.6-2.3c0-1.7-1.1-2.8-3.6-2.8h-3.2v11h3.1C283.9,132,285.5,131,285.5,128.8Zm-2.4-4.8c0,.9-.7,1.5-1.9,1.5h-1v-2.9h1.1C282.6,122.6,283.1,123.1,283.1,124Zm.4,4.7c0,1.1-.8,1.7-2.2,1.7h-1.1V127h1.1C282.7,127,283.5,127.6,283.5,128.7Zm5.8-6.8a1.1,1.1,0,0,0-1.2-1.1,1,1,0,0,0-1.1,1.1,1.1,1.1,0,0,0,1.1,1.1A1.1,1.1,0,0,0,289.3,121.9Zm-.2,10.1v-7.7h-1.9V132Zm4,0V120.4l-1.9.4V132Zm4,0V120.4l-1.9.4V132Zm2.9,2.9c1.4,0,2.3-.5,2.9-2.4l3-8.2H304l-1.8,5.4-1.7-5.5-2,.2,2.8,7.6v.2a1.4,1.4,0,0,1-1.4,1.1H299l.2,1.6Zm19.6-3.8v-5.3h-4.4l.2,1.7h2.3V130a3.8,3.8,0,0,1-1.9.4c-2.2,0-3.3-1.6-3.3-3.9s1-3.9,3.2-3.9a4.9,4.9,0,0,1,3,1l.4-2a6.8,6.8,0,0,0-3.4-.8c-3.4,0-5.4,2.3-5.4,5.7s1.9,5.7,5.4,5.7A6.9,6.9,0,0,0,319.6,131.1Zm8.9-3a3.7,3.7,0,0,0-3.7-4c-2.1,0-3.6,1.5-3.6,4s1.5,4.1,3.6,4.1S328.5,130.6,328.5,128.1Zm-1.9,0c0,1.5-.6,2.5-1.8,2.5s-1.8-1-1.8-2.5.6-2.4,1.8-2.4S326.6,126.7,326.6,128.1Zm7.6,1.8a2.5,2.5,0,0,1-1.8.8.8.8,0,0,1-.9-.9c0-.7.5-1.4,2.7-1.7Zm2,2.1v-5.3c0-1.9-1-2.6-3-2.6a9,9,0,0,0-3.1.6l.2,1.6a6.3,6.3,0,0,1,2.6-.7c.9,0,1.3.4,1.3,1.2v.2c-3.1.3-4.6,1.1-4.6,3a2,2,0,0,0,2.2,2.2,3.5,3.5,0,0,0,2.5-1.2l.2,1Zm6,0-.2-1.6h-.6c-.8,0-1-.3-1-.9v-3.7h1.8l-.3-1.5h-1.5v-2.8l-1.9.3v2.5h-1.1v1.5h1.1v4c0,1.8,1,2.3,2.5,2.3Z",
    style: {
      fill: "#dcddde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,58.1l-.3-2.4a6.4,6.4,0,0,1-3.5,1.2c-2.5,0-4.1-1.8-4.1-4.8s1.5-4.9,4-4.9a5.2,5.2,0,0,1,3.3,1.3l.4-2.5a6.3,6.3,0,0,0-3.8-1c-4,0-6.6,2.8-6.6,7.1s2.5,7.1,6.5,7.1A7.6,7.6,0,0,0,252.5,58.1ZM263,54.2c0-3.2-1.9-5.1-4.6-5.1s-4.5,1.9-4.5,5.1,1.9,5,4.5,5S263,57.3,263,54.2Zm-2.4,0c0,1.8-.7,3-2.2,3s-2.2-1.3-2.2-3,.8-3.1,2.2-3.1S260.6,52.4,260.6,54.2Zm9.6,2.1a2.9,2.9,0,0,1-2.2,1.1c-.8,0-1.2-.4-1.2-1.1s.6-1.8,3.4-2.1Zm2.4,2.7V52.4c0-2.3-1.2-3.3-3.7-3.3a11.2,11.2,0,0,0-3.9.8l.3,1.9a9.3,9.3,0,0,1,3.3-.7c1,0,1.6.4,1.6,1.4v.3c-3.9.4-5.8,1.4-5.8,3.7a2.5,2.5,0,0,0,2.7,2.7,4.1,4.1,0,0,0,3.3-1.5l.2,1.3Zm9.7-.7-.3-2.1a3.9,3.9,0,0,1-2.6.9c-1.4,0-2.5-.9-2.5-2.9s1-3,2.4-3a3.7,3.7,0,0,1,2.5.9l.4-2.1a5.1,5.1,0,0,0-3-.9c-2.6,0-4.7,1.8-4.7,5.1s1.9,5,4.6,5A5.5,5.5,0,0,0,282.3,58.3Zm10.1.7V52c0-1.8-.9-2.9-2.7-2.9a4.4,4.4,0,0,0-3.1,1.5v-6l-2.4.3V59h2.4V52.5a3.1,3.1,0,0,1,2.2-1.2c.9,0,1.2.5,1.2,1.4V59Z",
    style: {
      fill: "#f7e5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,182.1c0-2.2-1.1-3.2-3.9-4.3s-2.4-1.2-2.4-2.1.6-1.5,1.9-1.5a5.9,5.9,0,0,1,3.3,1.1l.4-2.4a7.8,7.8,0,0,0-3.7-.9c-2.5,0-4.4,1.5-4.4,3.9s1.1,3,3.7,4.1,2.5,1.3,2.5,2.3-.8,1.7-2,1.7a7.8,7.8,0,0,1-4-1.2l-.4,2.4a9.4,9.4,0,0,0,4.3,1C248.9,186.2,250.9,184.8,250.9,182.1Zm7.2,3.9-.3-2H257a1.1,1.1,0,0,1-1.2-1.2v-4.6H258l-.3-2h-1.9v-3.4l-2.4.4v3H252v2h1.4v5c0,2.2,1.3,2.9,3.2,2.9Zm1.7-9.7v7a2.6,2.6,0,0,0,2.8,2.9,4.5,4.5,0,0,0,3.2-1.6l.2,1.4h2.1v-9.7h-2.4v6.6a3.5,3.5,0,0,1-2.2,1.2,1.2,1.2,0,0,1-1.3-1.4v-6.4Zm12.7,5c0-2.1.9-3.1,2.1-3.1a3.8,3.8,0,0,1,1.9.4v4.1a2.9,2.9,0,0,1-2.2,1.4C273.2,184.1,272.5,183.2,272.5,181.3Zm-2.5.1c0,3.3,1.7,4.8,3.7,4.8a3.6,3.6,0,0,0,2.9-1.5l.2,1.3h2.1V171.6l-2.4.3v4.7a6.7,6.7,0,0,0-2.2-.4C272,176.2,270,177.8,270,181.4Zm15.2-3.6c1.1,0,1.7.8,1.9,2.3h-3.9C283.4,178.6,284.2,177.8,285.2,177.8Zm4.2,7.2-.3-1.9a5,5,0,0,1-3.3,1.2c-1.5,0-2.5-.8-2.6-2.7h6.2v-.5c0-2.8-1.3-5-4.2-5s-4.4,1.9-4.4,5.1,2.1,5,4.8,5A6.6,6.6,0,0,0,289.4,185Zm10.2,1v-7c0-1.8-.9-2.9-2.7-2.9a4.7,4.7,0,0,0-3.3,1.6l-.2-1.4h-2V186h2.4v-6.5a2.9,2.9,0,0,1,2.2-1.2c.9,0,1.2.5,1.2,1.4V186Zm7.6,0-.3-2h-.7c-1,0-1.3-.5-1.3-1.2v-4.6h2.3l-.3-2h-2v-3.4l-2.4.4v3h-1.3v2h1.3v5c0,2.2,1.3,2.9,3.2,2.9Zm14,0-.4-2.4h-4.6V172.2h-2.7V186Zm5.2-8.2c1.2,0,1.8.8,1.9,2.3h-3.8C324.6,178.6,325.4,177.8,326.4,177.8Zm4.2,7.2-.2-1.9a5.4,5.4,0,0,1-3.4,1.2c-1.4,0-2.5-.8-2.6-2.7h6.2a4.3,4.3,0,0,0,.1-.5c0-2.8-1.3-5-4.2-5s-4.4,1.9-4.4,5.1,2,5,4.7,5A6.6,6.6,0,0,0,330.6,185Zm7.3-1.7a3.3,3.3,0,0,1-2.3,1.1,1.1,1.1,0,0,1-1.2-1.1c0-1,.7-1.8,3.5-2.1Zm2.4,2.7v-6.6c0-2.3-1.3-3.3-3.8-3.3a10.7,10.7,0,0,0-3.8.8l.3,1.9a8.8,8.8,0,0,1,3.2-.7c1.1,0,1.7.4,1.7,1.4v.3c-3.9.4-5.8,1.4-5.8,3.7a2.5,2.5,0,0,0,2.7,2.7,4.1,4.1,0,0,0,3.2-1.5l.2,1.3Zm4.3-4.7c0-2.1.9-3.1,2.2-3.1a3.4,3.4,0,0,1,1.8.4v4.1a2.9,2.9,0,0,1-2.2,1.4C345.4,184.1,344.6,183.2,344.6,181.3Zm-2.4.1c0,3.3,1.6,4.8,3.6,4.8a4,4,0,0,0,3-1.5l.2,1.3h2V171.6l-2.4.3v4.7a6.7,6.7,0,0,0-2.2-.4C344.1,176.2,342.2,177.8,342.2,181.4Z",
    style: {
      fill: "#bed3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.8,313.1l2.7-.4-5.1-13.6h-2.8L241.4,313h2.7l1.2-3.5h5.2ZM247.9,302l1.9,5.3H246Zm16.5,11v-7a2.6,2.6,0,0,0-2.8-2.9,4.5,4.5,0,0,0-3.2,1.6l-.2-1.4h-2.1V313h2.4v-6.5a3.1,3.1,0,0,1,2.2-1.2c.9,0,1.3.5,1.3,1.4V313Zm5.1-12.6a1.4,1.4,0,0,0-2.8,0,1.4,1.4,0,0,0,2.8,0Zm-.2,12.6v-9.7h-2.4V313Zm16.4,0v-7c0-1.8-.9-2.9-2.7-2.9a4.6,4.6,0,0,0-3.3,1.6,2.4,2.4,0,0,0-2.5-1.6,4.5,4.5,0,0,0-3.1,1.6l-.2-1.4h-2.1V313h2.4v-6.5a2.9,2.9,0,0,1,2.2-1.2c.8,0,1.1.5,1.1,1.4V313H280v-6.5a2.7,2.7,0,0,1,2.1-1.2c.9,0,1.2.5,1.2,1.4V313Zm7.7-2.7a3.3,3.3,0,0,1-2.3,1.1,1.1,1.1,0,0,1-1.2-1.1c0-1,.7-1.8,3.5-2.1Zm2.4,2.7v-6.6c0-2.3-1.3-3.3-3.8-3.3a10.7,10.7,0,0,0-3.8.8l.3,1.9a8.8,8.8,0,0,1,3.2-.7c1.1,0,1.7.4,1.7,1.4v.3c-3.9.4-5.9,1.4-5.9,3.7a2.5,2.5,0,0,0,2.8,2.7,4.1,4.1,0,0,0,3.2-1.5l.2,1.3Zm4.8,0V298.6l-2.4.3V313Zm17.2-.9-.4-2.4a6.4,6.4,0,0,1-3.5,1.2c-2.5,0-4-1.8-4-4.8s1.5-4.9,4-4.9a5.4,5.4,0,0,1,3.3,1.3l.3-2.5a6.2,6.2,0,0,0-3.7-1c-4.1,0-6.6,2.8-6.6,7.1s2.5,7.1,6.5,7.1A7.6,7.6,0,0,0,317.8,312.1Zm7.8-6.6-.4-2.4a4,4,0,0,0-3.1,2.2l-.3-2h-2V313h2.4v-5.5A4.3,4.3,0,0,1,325.6,305.5Zm9.9,2.7c0-3.2-2-5.1-4.6-5.1s-4.5,1.9-4.5,5.1,1.9,5,4.5,5S335.5,311.3,335.5,308.2Zm-2.4,0c0,1.8-.7,3-2.2,3s-2.2-1.3-2.2-3,.8-3.1,2.2-3.1S333.1,306.4,333.1,308.2Zm11.5,2c0-1.9-1-2.5-3.5-3.2s-1.8-.7-1.8-1.2.4-.9,1.3-.9a7.3,7.3,0,0,1,3.1.9l.3-2a8.6,8.6,0,0,0-3.4-.7c-2.2,0-3.5,1.2-3.5,2.9s1,2.4,3.3,3,2,.7,2,1.4-.6,1-1.6,1a7.9,7.9,0,0,1-3.6-1.1l-.3,2a8.5,8.5,0,0,0,3.8.9C343.2,313.2,344.6,312.1,344.6,310.2Zm9,0c0-1.9-1-2.5-3.5-3.2s-1.8-.7-1.8-1.2.4-.9,1.3-.9a7.3,7.3,0,0,1,3.1.9l.3-2a8.9,8.9,0,0,0-3.4-.7c-2.2,0-3.5,1.2-3.5,2.9s.9,2.4,3.3,3,1.9.7,1.9,1.4-.5,1-1.6,1a7.6,7.6,0,0,1-3.5-1.1l-.3,2a8.5,8.5,0,0,0,3.8.9C352.2,313.2,353.6,312.1,353.6,310.2Zm4.6-9.8a1.3,1.3,0,0,0-1.4-1.4,1.4,1.4,0,0,0-1.5,1.4,1.4,1.4,0,0,0,1.5,1.3A1.3,1.3,0,0,0,358.2,300.4ZM358,313v-9.7h-2.4V313Zm10.7,0v-7c0-1.8-.9-2.9-2.7-2.9a4.5,4.5,0,0,0-3.2,1.6l-.3-1.4h-2V313h2.4v-6.5a3.1,3.1,0,0,1,2.2-1.2c.9,0,1.2.5,1.2,1.4V313Zm7.7-6.5a1.7,1.7,0,0,1-1.7,1.8,1.6,1.6,0,0,1-1.7-1.7,1.7,1.7,0,0,1,1.7-1.9A1.7,1.7,0,0,1,376.4,306.5Zm3.4,6.9c0-1.5-1.2-2.1-3.2-2.4h-1.3c-1.5-.2-1.8-.3-1.8-.6a.7.7,0,0,1,.4-.5h.8c2.1,0,3.9-1.2,3.9-3.3a3.1,3.1,0,0,0-.3-1.3h1.8l-.3-1.9-2.4.8a4.6,4.6,0,0,0-2.7-.9c-2.2,0-3.9,1.3-3.9,3.5a3.2,3.2,0,0,0,1.8,2.8q-1.2.8-1.2,1.5a1.6,1.6,0,0,0,.5,1.1c-1.2.6-1.8,1.3-1.8,2.2s2,2.4,4.6,2.4S379.8,315.5,379.8,313.4Zm-4.9,1.8c-1.8,0-2.7-.5-2.7-1.2a1.9,1.9,0,0,1,1-1.5l1.5.3H376c1.2.2,1.6.5,1.6,1S376.6,315.2,374.9,315.2Z",
    style: {
      fill: "#ed988d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.5,37.4l-6.4-2.8c-.1,0-.1-.2,0-.2l6.4-2.9h.1l2.8-6.4c0-.1.2-.1.2,0l2.9,6.4,6.4,2.9c.1,0,.1.2,0,.2l-6.4,2.8-2.9,6.4h-.2l-2.8-6.4Z",
    style: {
      fill: "#fdd2f8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 121,
    width: 216,
    height: 297,
    rx: 8,
    style: {
      fill: "#292841"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,129a8,8,0,0,1,8-8H605a8,8,0,0,1,8,8V305H397Z",
    style: {
      fill: "#1c1b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.7,278.5v-9h-7.5l.4,2.9h3.8v4.2a7.1,7.1,0,0,1-3.1.7c-3.8,0-5.7-2.6-5.7-6.7s1.9-6.6,5.5-6.6a8.8,8.8,0,0,1,5.2,1.8l.5-3.4a10.7,10.7,0,0,0-5.7-1.4c-5.7,0-9.1,3.9-9.1,9.7s3.2,9.6,9.1,9.6A12.7,12.7,0,0,0,477.7,278.5Zm11.2-8.6-.5-3.3a5.2,5.2,0,0,0-4.2,2.9l-.4-2.6H481V280h3.3v-7.5A5.9,5.9,0,0,1,488.9,269.9Zm8.8,6.5a4.4,4.4,0,0,1-3.1,1.4,1.4,1.4,0,0,1-1.6-1.5c0-1.3.9-2.4,4.7-2.8Zm3.2,3.6v-9c0-3.1-1.7-4.4-5-4.4a13.3,13.3,0,0,0-5.2,1.1l.4,2.6a10.9,10.9,0,0,1,4.3-1.1c1.5,0,2.3.6,2.3,2v.4c-5.3.5-7.9,1.9-7.9,5a3.5,3.5,0,0,0,3.7,3.7,6.1,6.1,0,0,0,4.4-2l.2,1.7Zm10.3-8.8a2.3,2.3,0,0,1-2.3,2.5,2.2,2.2,0,0,1-2.2-2.4c0-1.5.8-2.6,2.2-2.6A2.3,2.3,0,0,1,511.2,271.2Zm4.7,9.3c0-2-1.7-2.8-4.4-3.2l-1.7-.2c-2-.2-2.4-.4-2.4-.8a1,1,0,0,1,.5-.7H509c2.8,0,5.2-1.7,5.2-4.5a4.7,4.7,0,0,0-.3-1.7l2.4-.2-.5-2.6-3.2,1.2a5.5,5.5,0,0,0-3.7-1.3c-2.9,0-5.2,1.8-5.2,4.7a4.1,4.1,0,0,0,2.4,3.8c-1.1.6-1.6,1.3-1.6,2.1a1.7,1.7,0,0,0,.7,1.4c-1.6.9-2.4,1.9-2.4,3.1s2.6,3.2,6.2,3.2S515.9,283.4,515.9,280.5Zm-6.7,2.5c-2.5,0-3.6-.7-3.6-1.7s.4-1.3,1.4-2l1.9.4,1.8.2c1.6.2,2.2.6,2.2,1.3S511.5,283,509.2,283Zm16.1-11.8a2.3,2.3,0,0,1-2.3,2.5,2.3,2.3,0,0,1-2.3-2.4,2.3,2.3,0,0,1,2.3-2.6A2.3,2.3,0,0,1,525.3,271.2Zm4.6,9.3c0-2-1.7-2.8-4.3-3.2l-1.7-.2c-2.1-.2-2.5-.4-2.5-.8s.3-.5.6-.7h1c2.9,0,5.3-1.7,5.3-4.5a3.3,3.3,0,0,0-.4-1.7l2.4-.2-.4-2.6-3.2,1.2a5.7,5.7,0,0,0-3.7-1.3c-3,0-5.3,1.8-5.3,4.7a4,4,0,0,0,2.5,3.8c-1.1.6-1.7,1.3-1.7,2.1a1.9,1.9,0,0,0,.8,1.4c-1.7.9-2.5,1.9-2.5,3.1s2.7,3.2,6.2,3.2S529.9,283.4,529.9,280.5Zm-6.6,2.5c-2.5,0-3.7-.7-3.7-1.7s.5-1.3,1.4-2l2,.4,1.7.2c1.6.2,2.2.6,2.2,1.3S525.6,283,523.3,283Zm12.3-3V260.4l-3.2.6v19Zm8.7-11.1c1.5,0,2.3,1.1,2.6,3.2h-5.3C541.9,269.9,543,268.9,544.3,268.9Zm5.7,9.8-.4-2.6a7.5,7.5,0,0,1-4.5,1.6c-2,0-3.4-1.1-3.5-3.6H550v-.8c0-3.7-1.7-6.7-5.7-6.7s-5.9,2.6-5.9,6.9,2.7,6.8,6.4,6.8A9.4,9.4,0,0,0,550,278.7Z",
    style: {
      fill: "#99aab5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-5)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 193,
    r: 54,
    style: {
      fill: "#ffb869"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.3,210.6c6.3,22,31.6,37.1,52,22.8s.1-43.7.1-43.7,11.1-27.8-16.6-34.4S479.3,160.8,478.3,210.6Z",
    style: {
      fill: "#4d7ae8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.3,194.6c-3.1,0-5.6-3.3-5.6-7.5s2.5-7.4,5.6-7.4,5.5,3.3,5.5,7.4S522.3,194.6,519.3,194.6Z",
    style: {
      fill: "#dbe7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.6,192.8c-.7-.1-1.3-1.3-1.2-2.8s.8-2.7,1.6-2.6,1.4,1.3,1.3,2.8S522.4,192.9,521.6,192.8Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.7,173.2a6,6,0,0,0-2-2.7,5.5,5.5,0,0,0-6.6,0,6,6,0,0,0-2,2.7Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.1,204.9c-5.4,1.4-11.3.1-16.2-5.2a3.7,3.7,0,0,0-2.5-1.2,3.5,3.5,0,0,0-2.6.8,4,4,0,0,0-1.6,2.4,3.5,3.5,0,0,0,.6,2.8c7.4,12.2,19,14,26.2,7.1a3.6,3.6,0,0,0,1.1-1.6,3.1,3.1,0,0,0,0-1.9,4.4,4.4,0,0,0-.6-1.6,4.3,4.3,0,0,0-1.2-1.1,3.9,3.9,0,0,0-1.5-.6A4.9,4.9,0,0,0,525.1,204.9Z",
    style: {
      fill: "#590942"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521,205.5a14,14,0,0,0,4.1-.6h1.3v3.6s-2.1,1.6-10.2.7v-2l-14-4.7a4.7,4.7,0,0,1,.4-1.7,3.7,3.7,0,0,1,1.2-1.3h.1a3.6,3.6,0,0,1,2-.6h1.9c.1.2.3.2.3.3s.3,0,.3.2l.5.4a18,18,0,0,0,2.9,2.6l2,1.3a16,16,0,0,0,3,1.3A15.4,15.4,0,0,0,521,205.5Z",
    style: {
      fill: "#dbe7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.8,199.3h.1a3.6,3.6,0,0,1,2-.6h1.9c.1.1.3.1.3.3h.3l.5.5a7.5,7.5,0,0,0,1.6,1.5l-4,2.5-4.3-1.5a4.4,4.4,0,0,1,.5-1.5A3.2,3.2,0,0,1,503.8,199.3Z",
    style: {
      fill: "#b5cdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.2,165.4c5.1-11.5,14.1-13.8,29.6-10.1a32.4,32.4,0,0,1,8.9,3.5c.9,4.6-6.2,6-19.2,1.8C507.8,168.4,498.9,182.1,484.2,165.4Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.2,154.9l.7-9.4a5.7,5.7,0,0,0-.3-2.6,6,6,0,0,0-1.4-2.1,5.2,5.2,0,0,0-2.2-1.4,7.3,7.3,0,0,0-2.5-.4,7.1,7.1,0,0,0-2.8.9,6.4,6.4,0,0,0-2,2,6.6,6.6,0,0,0-.9,2.7,7.1,7.1,0,0,0,.5,2.9l4.3,9.7Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465,205.5l4.3,1.6,9-5.9v7.3l7.4,5.9a13,13,0,0,1,3.8,4.6,14.9,14.9,0,0,1,1.7,5.8l.3,5.9c10.9,9,25.7,11.9,38.8,2.7a24.7,24.7,0,0,0,5.6-5.1l4.4,1.5s-9,38-24.1,44.9-25.5,0-25.5,0c-15.7-53.6-11.1-63.6-50.1-48.2l-1.8-10.9Z",
    style: {
      fill: "#ef6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.2,188.4l-28.4-26.5-2.5,3.3,21.9,40.9Z",
    style: {
      fill: "#4d7ae8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.9,182.4l-11.2-7.9,8.6,15.5-1.6-6Z",
    style: {
      fill: "#3366e0"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 547,
    cy: 235,
    r: 12,
    style: {
      fill: "#6adbc6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,334.1l1.9-.4-2.6-3.7a2.8,2.8,0,0,0,2-2.8c0-1.8-1.3-2.9-3.5-2.9h-3V334h1.9v-3.7h.8Zm-.5-6.8c0,1-.8,1.6-1.9,1.6h-.9v-3.1h1C419,325.8,419.7,326.4,419.7,327.3Zm9.2,3.3c0-2.2-1.3-3.5-3.2-3.5s-3.1,1.3-3.1,3.5,1.3,3.5,3.1,3.5S428.9,332.8,428.9,330.6Zm-1.6,0c0,1.3-.5,2.2-1.6,2.2s-1.5-.9-1.5-2.2.5-2.1,1.5-2.1S427.3,329.4,427.3,330.6ZM432,334V323.9l-1.6.3V334Zm4.5-5.7c.8,0,1.2.5,1.3,1.6h-2.7C435.3,328.8,435.8,328.3,436.5,328.3Zm3,5-.2-1.3a4.3,4.3,0,0,1-2.3.8c-1.1,0-1.8-.5-1.9-1.9h4.4v-.4c0-1.9-.9-3.4-3-3.4s-3,1.3-3,3.5,1.4,3.5,3.3,3.5A4.8,4.8,0,0,0,439.5,333.3Zm6.4-1.3c0-1.3-.7-1.7-2.5-2.2s-1.2-.5-1.2-.8.3-.6.9-.6a3.9,3.9,0,0,1,2.1.6l.3-1.4a6,6,0,0,0-2.4-.5c-1.6,0-2.5.8-2.5,2s.7,1.7,2.3,2.1,1.4.5,1.4,1-.4.7-1.1.7a4.4,4.4,0,0,1-2.5-.8l-.2,1.4a6.2,6.2,0,0,0,2.6.6C444.9,334.1,445.9,333.3,445.9,332Z",
    style: {
      fill: "#b9bbbe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,346H541a12,12,0,0,1,12,12h0a12,12,0,0,1-12,12H426a12,12,0,0,1-12-12h0A12,12,0,0,1,426,346Z",
    style: {
      fill: "#ed988d",
      fillOpacity: 0.20000000298023224
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 358,
    r: 8,
    style: {
      fill: "#ed988d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,363.1l1.8-.3-3.5-9.5h-2l-3.6,9.7h1.9l.8-2.5h3.7Zm-2.8-7.8,1.3,3.7h-2.6Zm11.6,7.7v-4.9a1.8,1.8,0,0,0-2-2,3.1,3.1,0,0,0-2.2,1.1l-.2-1h-1.4V363h1.7v-4.6a2.2,2.2,0,0,1,1.5-.8c.6,0,.9.4.9,1V363Zm3.6-8.8a1,1,0,0,0-1-1,.9.9,0,0,0-1,1,.9.9,0,0,0,1,.9A1,1,0,0,0,462,354.2Zm-.2,8.8v-6.8h-1.7V363Zm11.5,0v-4.9a1.8,1.8,0,0,0-1.9-2,3.4,3.4,0,0,0-2.3,1.1,1.6,1.6,0,0,0-1.7-1.1,3.6,3.6,0,0,0-2.3,1.1v-1h-1.4V363h1.6v-4.6a2.2,2.2,0,0,1,1.5-.8c.7,0,.9.4.9,1V363h1.7v-4.6a2.1,2.1,0,0,1,1.5-.8c.6,0,.8.4.8,1V363Zm5.4-1.9a2.4,2.4,0,0,1-1.6.8.8.8,0,0,1-.9-.8c0-.7.5-1.2,2.5-1.5Zm1.6,1.9v-4.6c0-1.7-.8-2.3-2.6-2.3a7.2,7.2,0,0,0-2.7.5l.2,1.4a6.5,6.5,0,0,1,2.3-.6c.7,0,1.2.3,1.2,1.1h0c-2.8.3-4.1,1-4.1,2.7a1.7,1.7,0,0,0,1.9,1.8,3.1,3.1,0,0,0,2.3-1v.9Zm3.4,0V352.9l-1.6.3V363Zm12-.7-.2-1.6a4.8,4.8,0,0,1-2.5.9c-1.7,0-2.8-1.3-2.8-3.4s1-3.4,2.8-3.4a3.6,3.6,0,0,1,2.3.8l.3-1.7a4.5,4.5,0,0,0-2.7-.7c-2.8,0-4.6,2-4.6,5s1.8,5,4.6,5A4.9,4.9,0,0,0,495.7,362.3Zm5.5-4.5-.2-1.7a2.6,2.6,0,0,0-2.2,1.5l-.2-1.4h-1.5V363h1.7v-3.9A3.1,3.1,0,0,1,501.2,357.8Zm6.9,1.8c0-2.2-1.3-3.5-3.2-3.5s-3.1,1.3-3.1,3.5,1.3,3.5,3.1,3.5S508.1,361.8,508.1,359.6Zm-1.6,0c0,1.3-.5,2.2-1.6,2.2s-1.5-.9-1.5-2.2.5-2.1,1.5-2.1S506.5,358.4,506.5,359.6Zm8,1.4c0-1.3-.7-1.7-2.4-2.2s-1.3-.5-1.3-.8.3-.6.9-.6a4.6,4.6,0,0,1,2.2.6l.2-1.4a6,6,0,0,0-2.4-.5c-1.5,0-2.4.8-2.4,2s.6,1.7,2.3,2.1,1.3.5,1.3,1-.3.7-1.1.7a4.3,4.3,0,0,1-2.4-.8l-.3,1.4a7.2,7.2,0,0,0,2.7.6C513.6,363.1,514.5,362.3,514.5,361Zm6.3,0c0-1.3-.7-1.7-2.4-2.2s-1.3-.5-1.3-.8.3-.6.9-.6a4.6,4.6,0,0,1,2.2.6l.2-1.4a6,6,0,0,0-2.4-.5c-1.5,0-2.5.8-2.5,2s.7,1.7,2.4,2.1,1.3.5,1.3,1-.4.7-1.1.7a4.3,4.3,0,0,1-2.4-.8l-.3,1.4a7.2,7.2,0,0,0,2.7.6C519.8,363.1,520.8,362.3,520.8,361Zm3.2-6.8a.9.9,0,0,0-1-1,1,1,0,0,0-1,1,1,1,0,0,0,1,.9A.9.9,0,0,0,524,354.2Zm-.1,8.8v-6.8h-1.7V363Zm7.5,0v-4.9a1.8,1.8,0,0,0-1.9-2,3.6,3.6,0,0,0-2.3,1.1v-1h-1.4V363h1.6v-4.6a2.4,2.4,0,0,1,1.6-.8c.6,0,.8.4.8,1V363Zm5.4-4.6a1.2,1.2,0,0,1-1.2,1.3,1.2,1.2,0,0,1-1.2-1.2,1.2,1.2,0,0,1,1.2-1.3A1.2,1.2,0,0,1,536.8,358.4Zm2.4,4.9c0-1.1-.9-1.5-2.3-1.7H536c-1-.1-1.2-.2-1.2-.4s.1-.2.3-.4h.5a2.4,2.4,0,0,0,2.7-2.3c0-.4,0-.7-.2-.9h1.3l-.3-1.4-1.6.6a3.1,3.1,0,0,0-1.9-.6,2.5,2.5,0,0,0-2.8,2.4,2.2,2.2,0,0,0,1.3,2,1.4,1.4,0,0,0-.8,1,.9.9,0,0,0,.4.8c-.9.4-1.3.9-1.3,1.6s1.4,1.6,3.2,1.6S539.2,364.7,539.2,363.3Zm-3.5,1.3c-1.3,0-1.9-.4-1.9-.9s.3-.7.8-1h1.9c.8.2,1.1.4,1.1.7S536.9,364.6,535.7,364.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,378h96a12,12,0,0,1,12,12h0a12,12,0,0,1-12,12H427a12,12,0,0,1-12-12h0A12,12,0,0,1,427,378Z",
    style: {
      fill: "#bed3ff",
      fillOpacity: 0.2199999988079071
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427,
    cy: 390,
    r: 8,
    style: {
      fill: "#bed3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.9,392.2c0-1.5-.7-2.1-2.7-3s-1.7-.8-1.7-1.4.4-1.1,1.4-1.1a4,4,0,0,1,2.2.8l.3-1.7a5.7,5.7,0,0,0-2.5-.6c-1.8,0-3.1,1-3.1,2.7s.7,2.1,2.6,2.9,1.7.9,1.7,1.6-.6,1.2-1.4,1.2a5.5,5.5,0,0,1-2.8-.9l-.3,1.7a7.4,7.4,0,0,0,3.1.7C448.5,395.1,449.9,394.1,449.9,392.2ZM455,395l-.3-1.4h-.5c-.6,0-.9-.3-.9-.8v-3.2h1.6l-.2-1.4h-1.4v-2.4l-1.6.3v2.1h-1v1.4h1v3.5c0,1.5.9,2,2.2,2Zm1.2-6.8v4.9c0,1.3.6,2,1.9,2a3.6,3.6,0,0,0,2.3-1.1v1H462v-6.8h-1.7v4.6a2.3,2.3,0,0,1-1.6.8c-.6,0-.8-.4-.8-.9v-4.5Zm8.8,3.5c0-1.5.7-2.2,1.5-2.2a3.2,3.2,0,0,1,1.4.3v2.9a2.1,2.1,0,0,1-1.6.9C465.6,393.6,465,393,465,391.7Zm-1.7.1c0,2.3,1.2,3.3,2.6,3.3a2.6,2.6,0,0,0,2-1l.2.9h1.4V384.9l-1.6.3v3.2l-1.6-.2C464.7,388.2,463.3,389.3,463.3,391.8Zm10.6-2.5c.8,0,1.3.5,1.4,1.6h-2.7C472.7,389.8,473.3,389.3,473.9,389.3Zm3,5-.2-1.3a4,4,0,0,1-2.3.8c-1.1,0-1.8-.5-1.8-1.9h4.3v-.4c0-1.9-.9-3.4-2.9-3.4s-3.1,1.3-3.1,3.5,1.4,3.5,3.3,3.5A4.6,4.6,0,0,0,476.9,394.3Zm7.1.7v-4.9a1.8,1.8,0,0,0-1.9-2,3.6,3.6,0,0,0-2.3,1.1v-1h-1.4V395h1.6v-4.6a2.4,2.4,0,0,1,1.6-.8c.6,0,.9.4.9,1V395Zm5.4,0-.3-1.4h-.5c-.6,0-.9-.3-.9-.8v-3.2h1.6l-.2-1.4h-1.4v-2.4l-1.6.3v2.1h-1v1.4h1v3.5c0,1.5.9,2,2.2,2Zm9.7,0-.2-1.7h-3.3v-8h-1.8V395Zm3.7-5.7c.8,0,1.2.5,1.3,1.6h-2.7C501.5,389.8,502.1,389.3,502.8,389.3Zm2.9,5-.2-1.3a3.8,3.8,0,0,1-2.3.8c-1,0-1.7-.5-1.8-1.9h4.3a1,1,0,0,0,.1-.4c0-1.9-1-3.4-3-3.4s-3.1,1.3-3.1,3.5,1.4,3.5,3.3,3.5A4.6,4.6,0,0,0,505.7,394.3Zm5.1-1.2a2.3,2.3,0,0,1-1.6.8.7.7,0,0,1-.8-.8c0-.7.5-1.2,2.4-1.5Zm1.7,1.9v-4.6c0-1.7-.9-2.3-2.6-2.3a7.2,7.2,0,0,0-2.7.5l.2,1.4a6,6,0,0,1,2.2-.6c.8,0,1.2.3,1.2,1.1h0c-2.7.3-4.1,1-4.1,2.7a1.8,1.8,0,0,0,2,1.8,2.7,2.7,0,0,0,2.2-1v.9Zm3-3.3c0-1.5.6-2.2,1.5-2.2a2.5,2.5,0,0,1,1.3.3v2.9a1.8,1.8,0,0,1-1.5.9C516.1,393.6,515.5,393,515.5,391.7Zm-1.7.1c0,2.3,1.2,3.3,2.6,3.3a2.6,2.6,0,0,0,2-1l.2.9H520V384.9l-1.7.3v3.2l-1.5-.2C515.2,388.2,513.8,389.3,513.8,391.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-6)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 346,
    r: 14,
    style: {
      fill: "#ffb869"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,350.6c1.6,5.7,8.2,9.6,13.5,5.9s0-11.4,0-11.4,2.9-7.2-4.3-8.9S248.1,337.6,247.8,350.6Z",
    style: {
      fill: "#4d7ae8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4,346.4c-.8,0-1.4-.9-1.4-1.9s.6-1.9,1.4-1.9a1.7,1.7,0,0,1,1.5,1.9A1.8,1.8,0,0,1,258.4,346.4Z",
    style: {
      fill: "#dbe7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,345.9c-.2,0-.4-.3-.4-.7s.2-.7.5-.7.3.4.3.8S259.3,346,259.1,345.9Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1,340.9a1.3,1.3,0,0,0-.5-.7,1.6,1.6,0,0,0-.9-.3,1.1,1.1,0,0,0-.8.3c-.3.1-.4.4-.5.7Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,349.1a4.1,4.1,0,0,1-4.2-1.3,1,1,0,0,0-.7-.4l-.7.2a1.6,1.6,0,0,0-.4.7,1,1,0,0,0,.2.7c1.9,3.1,4.9,3.6,6.8,1.8a.5.5,0,0,0,.2-.4.9.9,0,0,0,.1-.5c-.1-.1-.1-.3-.2-.4l-.3-.3h-.4C260.2,349,260.1,349,260,349.1Z",
    style: {
      fill: "#590942"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,349.2h1.4v.9s-.6.4-2.6.2v-.5l-3.7-1.2c0-.2.1-.3.1-.5l.3-.3h1.4a2.3,2.3,0,0,0,.7.7l.5.3a1.3,1.3,0,0,0,.8.3A2.2,2.2,0,0,0,258.9,349.2Z",
    style: {
      fill: "#dbe7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,347.6h.1a.4.4,0,0,1,.5-.1c0-.1.1,0,.1,0h.4c0,.1.1,0,.1.1h.2c.1.1.2.3.4.4l-1.1.6-1.1-.4c0-.1.1-.2.1-.4Z",
    style: {
      fill: "#b5cdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,338.8c1.4-2.9,3.7-3.5,7.7-2.6a9.2,9.2,0,0,1,2.3.9c.2,1.2-1.6,1.6-4.9.5C255.5,339.6,253.2,343.2,249.3,338.8Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,336.1l.2-2.4a1.7,1.7,0,0,0-.1-.7l-.3-.5-.6-.4h-.7l-.7.2c-.2.2-.4.3-.5.5a2.4,2.4,0,0,0-.2.8.9.9,0,0,0,.1.7l1.1,2.5Z",
    style: {
      fill: "#201e2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,349.2l1.1.4,2.3-1.5V350l1.9,1.5a3.5,3.5,0,0,1,1,1.2,4.4,4.4,0,0,1,.5,1.5v1.6c2.9,2.3,6.7,3.1,10.1.7a6.2,6.2,0,0,0,1.4-1.4l1.2.4s-2.3,9.9-6.2,11.7a7.2,7.2,0,0,1-6.7,0c-4-13.9-2.9-16.5-13-12.5l-.4-2.8Z",
    style: {
      fill: "#ef6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,344.8l-7.4-6.9-.7.9,5.7,10.6Z",
    style: {
      fill: "#4d7ae8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,343.3l-2.9-2.1,2.2,4-.4-1.5Z",
    style: {
      fill: "#3366e0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M571,81.4a69.3,69.3,0,0,0-12.2-12c3.4-7.2,4.1-9.2,2.9-11.5-2.3-4.4-8.8-7.7-16.8-6.7a4.9,4.9,0,0,0-2.4.8,5.5,5.5,0,0,0-1.8,1.6l-6.1,9.1-11,18.2C504.9,62,497,59.2,484.9,62.2s-13.3,15-11.4,22.3S480.4,97,482.1,99a31.5,31.5,0,0,0-13.3,1.3,3.3,3.3,0,0,0-1.4,1,4.2,4.2,0,0,0-.9,1.4,66.5,66.5,0,0,0-3.1,13.9c-.4,2.9,18,5.2,28.9,5.2h70.4c1.4-5.1,0-11.3,0-11.3s7.2-13.6,10-18.3S574.1,85.8,571,81.4Z",
    style: {
      fill: "#ff78b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.6,80.9c6.1,6.6,16,11.2,16,11.2,5.4-16.7,6.3-26.2,10.3-27s6,1.9,8.9,4.3c3.4-7.2,4.1-9.2,2.9-11.5-2.3-4.5-8.8-7.7-16.8-6.7a6.1,6.1,0,0,0-2.4.7,7.3,7.3,0,0,0-1.8,1.7l-6.1,9Z",
    style: {
      fill: "#ffa8d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.1,108.6,498.2,97.9l-18.8-2.4a41.1,41.1,0,0,0,2.7,3.5,31.7,31.7,0,0,0-13.3,1.3,3.3,3.3,0,0,0-1.4,1,4.2,4.2,0,0,0-.9,1.4,66.5,66.5,0,0,0-3.1,13.9c-.4,2.9,18,5.2,28.9,5.2h70.4a28,28,0,0,0,.5-12.2C556.6,109.4,544.7,109.1,534.1,108.6Z",
    style: {
      fill: "#ffa8d2"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M497.8,72.7c-9.7-11.7-20.6-9.5-23.9-1.3a22.5,22.5,0,0,0-.3,13.1c1.5,6.1,6.8,12.5,8.5,14.5,20.7,2.1,32.4,8.9,52.1,9.6C513.6,96.4,506.5,83.1,497.8,72.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M490.5,121.8c-19.6,0-37-4.6-21.6-7.1s31.3,7.1,49.9,7.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.4,106.5c-.1.1-.1.1-.1.2,7.3-3.1,20-2.2,37,2.8s29.3,5.6,61.4,5.6v-1.8c-31.9,0-43.7-.4-60.9-5.5-15-4.5-26.9-5.8-34.9-3.8a3.4,3.4,0,0,0-2.5,2.5Z",
    style: {
      fill: "#ff78b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.7,97.2c2,0,3.6-3.2,3.6-7.2s-1.6-7.2-3.6-7.2S549,86,549,90,550.6,97.2,552.7,97.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,102.4c-4.8,4.2-9.4.7-8.1-6.4A98.9,98.9,0,0,0,519,102.4Z",
    style: {
      fill: "#66bcff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.8,91c-3.2,5.5-7.8,2.8-7.9-1.2-5.4,0-5.6-4.9-1.6-9.9A111.3,111.3,0,0,0,505.8,91Z",
    style: {
      fill: "#66bcff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.9,69.2c-5.2,7.7-6.8,7.2-7.9,5.6-4.7,6.1-4.7.7-2-4.1S481.9,66.5,485.9,69.2Z",
    style: {
      fill: "#66bcff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.8,85.2c-2.3,7.1.5,9,3.9,7.1C478.3,90,477,87.6,475.8,85.2Z",
    style: {
      fill: "#66bcff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M551.6,87.5c-.9-.2-1.8.4-2.6,1.6V90a11.4,11.4,0,0,0,1.6,5.9,5.9,5.9,0,0,0,2.3-3.5C553.4,90,552.9,87.8,551.6,87.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M533,115.3l-.7-.3a1.1,1.1,0,0,1-.3-.8,16.7,16.7,0,0,1,4.3-10.8.8.8,0,0,1,.7-.4,1.1,1.1,0,0,1,.8.3,1.6,1.6,0,0,1,.4.7,1.1,1.1,0,0,1-.3.8,15.4,15.4,0,0,0-3.8,9.4,1.1,1.1,0,0,1-.3.8,1.1,1.1,0,0,1-.7.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113,421.5s-11.6-20.8-22.3-35.9l-18.9,7s18.8,22.7,23.9,40.5h2a46.9,46.9,0,0,0,15.4-2.5c5.1-1.7,9.3-4.1,11.1-7.2C124.2,421.1,120.7,421.5,113,421.5Z",
    style: {
      fill: "#ffc619"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1,393.5c-1.8-2.7-3.6-5.4-5.4-7.9l-18.9,7s5.2,6.3,10.9,14.9C81.3,400.5,92.4,395.1,96.1,393.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,424.5c7.4-16.1,6.9-21.7,3.7-36.9L55.5,387c4.5,17.9,5.1,25.7-1.5,40.6a10.2,10.2,0,0,0-.6,5.5H85.3C86.1,430.2,83.4,428.9,72.2,424.5Z",
    style: {
      fill: "#ffc619"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4,395.3c-.4-2.3-.9-4.9-1.5-7.7l-20.4-.7a121.4,121.4,0,0,1,3.2,15.7h0S68.5,397,77.4,395.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,318.6a11.9,11.9,0,0,0-.8-8.5,4.6,4.6,0,0,1-.4-2.8,4.2,4.2,0,0,1,1.2-2.6,12,12,0,0,0,2-4.1c1.5-5.4-.8-10.9-5.1-12.2s-8.9,1.8-10.4,7.2a11.2,11.2,0,0,0,.8,8.4,5.5,5.5,0,0,1,.4,2.8,4.2,4.2,0,0,1-1.2,2.6,13.5,13.5,0,0,0-2,4.2c-1.5,5.3.8,10.8,5.1,12.2S99.3,323.9,100.8,318.6Z",
    style: {
      fill: "#ffd751"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1,313a9,9,0,0,0,.2-4.3,5,5,0,0,1,.4-3.4,24.4,24.4,0,0,0,1-2.4c.7-3.1.1-6-1.4-6.5s-3.3,1.7-4.1,4.7a8.8,8.8,0,0,0,.1,5.1,1.8,1.8,0,0,1,.1,1,1.7,1.7,0,0,1-.3,1,12.3,12.3,0,0,0-1.4,3.1c-.9,3-.2,5.9,1.3,6.4S97.4,316.1,98.1,313Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,390.3l-46.6,6.5a5,5,0,0,1-2.4-.3,4,4,0,0,1-1.9-1.5L20.9,357.8a4.4,4.4,0,0,1-1-2.2,5,5,0,0,1,.3-2.4L38,309.5a5.2,5.2,0,0,1,1.4-1.9,4.3,4.3,0,0,1,2.2-.9l46.7-6.5a5,5,0,0,1,2.4.3,5.2,5.2,0,0,1,1.9,1.4l28.9,37.3a4.3,4.3,0,0,1,.9,2.2,4,4,0,0,1-.3,2.4l-17.7,43.7a5.2,5.2,0,0,1-1.4,1.9A5,5,0,0,1,100.7,390.3Z",
    style: {
      fill: "#29cc7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,395.5l-.7-.2a1.3,1.3,0,0,1-.5-.6l-5-14.6L20.8,356.7a1.2,1.2,0,0,1-.4-.8.8.8,0,0,1,.2-.8L38,324.8c.2-.2.4-.5.7-.6a1.7,1.7,0,0,1,1,.1L88,345l.4.4c.2.1.3.2.3.4l13.8,41.9a1.5,1.5,0,0,1,.1.7l-.3.6c-.2.1-.3.3-.6.3h-.6L48.6,381,53,393.8c0,.1.1.3,0,.5a.9.9,0,0,1-.1.5l-.3.4-.4.3Zm-4.5-17.4,52.2,8.4-13-39.3-46.7-20L23.4,355.5Z",
    style: {
      fill: "#15ad75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,380.7a1.8,1.8,0,0,1-.9-.4,1.2,1.2,0,0,1-.4-.8l-7.4-53.9c-.1,0-.1-.1,0-.2l1-16.5a1.3,1.3,0,0,1,.4-.9,1.7,1.7,0,0,1,1-.3,1.2,1.2,0,0,1,.8.4,1.2,1.2,0,0,1,.4.9l-1,16.4,7.4,53.8a1.2,1.2,0,0,1-.2,1l-.9.5Z",
    style: {
      fill: "#15ad75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,380.7l-.6-.2-.4-.3a1.7,1.7,0,0,1-.3-1,1.2,1.2,0,0,1,.5-.9l40.8-33.1a.9.9,0,0,1,.7-.3l33.4-4.6a1.7,1.7,0,0,1,1,.3,1.5,1.5,0,0,1,.2,1.8l-.8.5L88,347.5,47.4,380.4A1.1,1.1,0,0,1,46.6,380.7Z",
    style: {
      fill: "#15ad75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,347.5h-.6l-.4-.3-.3-.4a4.3,4.3,0,0,0-.1-.5l1.8-41.7L39.7,326.7a1.7,1.7,0,0,1-1,0,2.3,2.3,0,0,1-.7-.7,1.7,1.7,0,0,1,0-1,1.1,1.1,0,0,1,.6-.7l50.2-23.1h.6l.7.2.4.5a.9.9,0,0,1,.1.7l-1.8,43.8a1.8,1.8,0,0,1-.4.9A1.6,1.6,0,0,1,87.5,347.5Z",
    style: {
      fill: "#15ad75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,312.6a16.1,16.1,0,0,0-5.5-8.9,6.8,6.8,0,0,1-2.2-6.2,11.4,11.4,0,0,0-.2-5.2c-1.4-6.4-6.7-11.6-11.9-11.6s-8.2,5.2-6.8,11.6a16.1,16.1,0,0,0,5.5,8.9,7,7,0,0,1,1.9,2.8,6.5,6.5,0,0,1,.3,3.4,13,13,0,0,0,.1,5.2c1.5,6.3,6.8,11.5,12,11.5S80.5,319,79.1,312.6Z",
    style: {
      fill: "#ffd751"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,309.7a14.6,14.6,0,0,0-2-4.6,6.5,6.5,0,0,1-1.3-3.8,14.5,14.5,0,0,0-.4-2.9c-.8-3.6-3-6.9-4.9-7.3s-2.8,2.4-1.8,6.3a13.3,13.3,0,0,0,3,5.9,6.1,6.1,0,0,1,.7,1,5.9,5.9,0,0,1,.2,1.3,9.3,9.3,0,0,0,.2,3.7c.7,3.6,3,6.5,4.7,6.5S74.5,313,73.7,309.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106,368.5c-1.4,0-2.8-1-4-2.8s-4.8-9.5-6.3-14a1.2,1.2,0,0,1,.1-1,1.1,1.1,0,0,1,.7-.6,1.7,1.7,0,0,1,1,0,1.4,1.4,0,0,1,.7.8c1.4,4.3,4.3,10.9,6,13.3s1.4,1.6,1.9,1.6,1.1-.5,1.6-1.5a51.8,51.8,0,0,0,3.5-8.3l1.8-4.7a1.6,1.6,0,0,1,.7-.7,1.2,1.2,0,0,1,1,.1,1.3,1.3,0,0,1,.7.6,1.7,1.7,0,0,1,0,1c-.6,1.5-1.1,3.1-1.7,4.6a54.2,54.2,0,0,1-3.7,8.8c-1.4,2.2-2.9,2.7-3.8,2.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94,353.3a1.1,1.1,0,0,1-.8-.3,1.3,1.3,0,0,1-.5-.7,2.5,2.5,0,0,1,.1-.8,1.8,1.8,0,0,1,.5-.7,23.4,23.4,0,0,0,4.1-2.9,1.9,1.9,0,0,1,1-.3,1.2,1.2,0,0,1,.9.5,1.4,1.4,0,0,1,.3.9,1.1,1.1,0,0,1-.5.9,44.8,44.8,0,0,1-4.4,3.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,425.8H67.3a1.5,1.5,0,0,1-.9-.4,1.2,1.2,0,0,1-.4-.9,1.3,1.3,0,0,1,.4-1,1.5,1.5,0,0,1,.9-.4h4.9a1.5,1.5,0,0,1,.9.4,1.3,1.3,0,0,1,.4,1,1.2,1.2,0,0,1-.4.9A1.5,1.5,0,0,1,72.2,425.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.6,424a.9.9,0,0,1-.8-.4,1.4,1.4,0,0,1-.5-.8,2.9,2.9,0,0,1,.2-.9l.8-.5,4.4-1.2a1.6,1.6,0,0,1,1,.1,1.5,1.5,0,0,1,.6.9,1.3,1.3,0,0,1-.1.9c-.2.3-.5.6-.8.6l-4.4,1.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.4,401a7,7,0,0,1-4-.9,6.6,6.6,0,0,1-2.6-3.3,274.5,274.5,0,0,0-11.4-26.9,7.1,7.1,0,0,1-.6-2.4,6.1,6.1,0,0,1,3.5-6,5.8,5.8,0,0,1,4.8-.3,6,6,0,0,1,3.6,3.2,291,291,0,0,1,12,28.2,6.7,6.7,0,0,1,.3,2.8,6.3,6.3,0,0,1-1,2.7,6.4,6.4,0,0,1-2,2,6.2,6.2,0,0,1-2.6.9Z",
    style: {
      fill: "#2331b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4,339.7a28,28,0,1,0-28-28A27.9,27.9,0,0,0,200.4,339.7Z",
    style: {
      fill: "#8cd9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.7,329.5c-10.2-2.7-19.4-2.8-22.9-.5a4.3,4.3,0,0,0-1.1,1.2,3.2,3.2,0,0,0-.2,1.7l1.8,16.1,32.9,8.7,9.5-13.2a4.4,4.4,0,0,0,.6-1.6,4.1,4.1,0,0,0-.3-1.6C214,336.6,205.9,332.2,195.7,329.5Z",
    style: {
      fill: "#b5e4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,355c1.1-4.4-9.1-10.9-22.8-14.5s-25.7-2.9-26.9,1.5,9,11,22.7,14.6S214.4,359.5,215.6,355Z",
    style: {
      fill: "#7ac5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.2,341.1a5.5,5.5,0,0,1,1.2-2.4,7.3,7.3,0,0,1,2.3-1.6c6.2-2.4,15.7-2.2,24,0s16.8,6.6,21,11.8a5.8,5.8,0,0,1,1.2,2.5,5,5,0,0,1-.1,2.7l-.2.9-49.7-12.9Z",
    style: {
      fill: "#7ac5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,354.7c.8-2.8-7-7.2-17.4-10s-19.3-2.6-20,.2,7,7.3,17.4,10S208.4,357.5,209.1,354.7Z",
    style: {
      fill: "#b5e4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9,427.7c-11.8-35,.2-72.9.2-72.9l-18.7-5-17.8,68.3Z",
    style: {
      fill: "#b5e4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,408.7C163.7,384,171.7,345,171.7,345l18.7,4.8-17.8,68.3Z",
    style: {
      fill: "#b5e4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6,427.2c1.5-6-15-15.4-36.9-21s-41-5.5-42.6.5,15.1,15.4,37,21S211.1,433.2,212.6,427.2Z",
    style: {
      fill: "#3f99f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,406.6a8.7,8.7,0,0,1,1.7-3.3,7.9,7.9,0,0,1,3.1-2c7.5-2.6,22.6-1.8,38.3,2.4s29.2,10.7,34.5,16.7a6.7,6.7,0,0,1,1.7,3.2,7.7,7.7,0,0,1,0,3.7l-.3,1.2L133,407.8Z",
    style: {
      fill: "#3f99f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,426.2c-16.8-4.4-31.1-10.7-32-14.4s14.7-3.5,35.3,1.9,34.5,12.5,31.6,15.6S187.3,430.6,170.5,426.2Z",
    style: {
      fill: "#2331b5"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5,411.8c.5,1.7,3.7,4,8.7,6.3l3.1-8.7C142.6,408.7,138,409.5,138.5,411.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.1,429.7c9.4,1.4,16.6,1.4,18.3-.4s-4.4-6.4-15.7-10.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,360.4l-.3-.7c-2.3,4.3-4.1,8.4-.6,9.3s11.6-2.7,22.9-9.1l-.2-1.8C179.3,363.2,170,364.6,171.4,360.4Z",
    style: {
      fill: "#5865f2"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4,360.4l-.3-.7c-2.3,4.2-4,8.2-.8,9.3a16.4,16.4,0,0,1,1.8-6.5l-.5-.4-.3-.5V361C171.3,360.8,171.4,360.6,171.4,360.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4,361.8l.6,1.5a2.8,2.8,0,0,0,.8,1.1,3.5,3.5,0,0,0,1.2.7c2.6.6,7.7-.3,19.4-5.2l-.2-1.8C181.1,362.6,172.5,364.2,171.4,361.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9,363.4h-.5a1,1,0,0,1-.5-.4,8.3,8.3,0,0,1-1.4-6.1.7.7,0,0,1,.1-.5l.4-.4c.1-.2.3-.2.4-.3h.6l.5.2c.1.1.3.2.4.4s.1.3.2.5v.5a5.5,5.5,0,0,0,.9,4.1,1.2,1.2,0,0,1,.2,1,1,1,0,0,1-.5.8A1.1,1.1,0,0,1,193.9,363.4Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M170.3,361.5l-.7-.2a1.2,1.2,0,0,1-.5-.7,1.1,1.1,0,0,1,0-.8,1.8,1.8,0,0,1,.5-.7l1.8-1a1.2,1.2,0,0,1,1,.1.9.9,0,0,1,.6.7,1,1,0,0,1,.1.9,1.8,1.8,0,0,1-.7.8l-1.3.7A1.1,1.1,0,0,1,170.3,361.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.4,308.5a12.3,12.3,0,0,1,3.1-5.7A14,14,0,0,1,186,299a10.5,10.5,0,0,1,3.5-.8,6.3,6.3,0,0,1,3.8.9,4,4,0,0,1,1.5,1.4,6.1,6.1,0,0,1,.9,1.8,5.6,5.6,0,0,1-.5,3.6l-.3.3h-.6v-.2a7.7,7.7,0,0,0-1-2.5,3,3,0,0,0-1.5-1.2,7.7,7.7,0,0,0-4.5.2,17.2,17.2,0,0,0-4.8,2.6,22.2,22.2,0,0,0-4,4.1c0,.1-.2.2-.3.2s-.3,0-.4,0-.3-.2-.3-.3a.6.6,0,0,1-.1-.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.1,385.3a135.4,135.4,0,0,1,22.8,14.5,6.1,6.1,0,0,0,2.3,1.1,5.2,5.2,0,0,0,2.5.2,6.2,6.2,0,0,0,2.3-.7,6.3,6.3,0,0,0,1.9-1.7,7,7,0,0,0,1.1-2.3,5.2,5.2,0,0,0,.1-2.5,6.3,6.3,0,0,0-.8-2.3,6.6,6.6,0,0,0-1.8-1.9c-11.9-9-20.7-13.8-25-15.8s-6.7-2.3-12.8-1.7c-2.4.2-3,1.1-4.4,5.6s.7,5.8,5.4,5.3C183.7,382.9,185.4,383.9,188.1,385.3Z",
    style: {
      fill: "#2331b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,372.4a8.1,8.1,0,0,0-5.2,1.5,6.4,6.4,0,0,0-2,2,7.5,7.5,0,0,0-.7,1.2c-2.1,3.3-3,4.8-2.9,5.8a13.3,13.3,0,0,0,1,2.8c.4-.5.7-1.1,1.1-1.7,2.1-3.4,5.9-2.7,7.4-2.8s2.2-3.4,3.2-5.9S167.1,372.3,164.7,372.4Z",
    style: {
      fill: "#2331b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,373.3c-2-.8-3.2-3.3-3.8-4.8s-1.7-1.1-2.9-.7-1.4,1.6.2,5.1S192,373.3,192,373.3Z",
    style: {
      fill: "#2331b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,265.1a11.3,11.3,0,0,1-3.6-3.6,12.8,12.8,0,0,1-1.8-4.7l-.8-5.9-.2-.3-.4-.2-.4.2-.2.3-.9,5.9a10,10,0,0,1-1.8,4.7,11,11,0,0,1-3.5,3.6l-.8.5a.2.2,0,0,0-.2.2.4.4,0,0,0-.1.3h0a.4.4,0,0,0,.1.3.2.2,0,0,0,.2.2l.8.5a12,12,0,0,1,3.5,3.6,10,10,0,0,1,1.8,4.7l.9,5.9.2.3.4.2.4-.2.2-.3.8-5.9a12.8,12.8,0,0,1,1.8-4.7,12.4,12.4,0,0,1,3.6-3.6l.8-.5c.1,0,.1-.1.2-.2v-.3h0c0-.1-.1-.2-.1-.3s-.1-.2-.2-.2Z",
    style: {
      fill: "#ffa8d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,200.4a6.2,6.2,0,0,1-1.8-1.8,5,5,0,0,1-.9-2.4l-.4-3V193h-.4v.2l-.5,3a5,5,0,0,1-.9,2.4,6.2,6.2,0,0,1-1.8,1.8l-.4.3a.1.1,0,0,0-.1.1v.2h.2l.4.3a6.2,6.2,0,0,1,1.8,1.8,5,5,0,0,1,.9,2.4l.5,3c0,.1,0,.1.1.2h.4v-.2l.4-3a5,5,0,0,1,.9-2.4,6.2,6.2,0,0,1,1.8-1.8l.4-.3h.2v-.2a.1.1,0,0,0-.1-.1Z",
    style: {
      fill: "#5865f2"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashModeration);
export default __webpack_public_path__ + "static/media/splash_moderation.0f86574cd97c55f5bfc0494c38ad5a38.svg";
export { ForwardRef as ReactComponent };